// extracted by mini-css-extract-plugin
export var button = "_1b-1";
export var featuredLink = "_1b-4";
export var spinner = "_1b-2";
export var spinnerContainer = "_1b-3";
export var text = "_1b-0";